import { useEffect, useRef, useState } from "react";
import AudioSrc from "../../Audio/test.mp3";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

const BackGroundAudio = ({ volume = 1.0, loop = true }) => {
  const { pathname } = useLocation();
  const [play, setPlay] = useState(false);
  const audioRef = useRef(new Audio(AudioSrc));
  const { soundMuted } = useSelector(({ user }) => user);

  useEffect(() => {
    if (!localStorage.getItem("soudMuted")) {
      localStorage.setItem("soudMuted", JSON.stringify(true));
    }
  }, []);

  useEffect(() => {
    const match =
      pathname.match(/\/questions\/(\d+)/) ||
      pathname.match(/\/question\/(\d+)/) ||
      pathname.match(/\/wordGame\/(\d+)/);
    if (match) {
      setPlay(true);
    } else {
      setPlay(false);
    }
    return () => {
      setPlay(false);
    };
  }, [pathname]);

  useEffect(() => {
    const audio = audioRef.current;
    if (play && soundMuted) {
      audio.volume = volume;
      audio.loop = loop;

      audio.play().catch((error) => console.log("Error with playback:", error));
    }
    return () => {
      audio.pause();
    };
  }, [soundMuted, play, volume, loop]);
  return null;
};

export default BackGroundAudio;
